import { bursariesApi } from "../api/hliLists";
import { Container, PageHeader, Select } from "./ui";
import AdmittedStudentsTable from "./bursaries/AdmittedStudentsTable";
import { useYearState } from "./bursaries/shared";

// The admitted students the signed-in HLI admin's institution uploaded for a year
export default function HliBursaryApplications() {
  const [year, setYear, years] = useYearState();

  return (
    <Container className="flex flex-col gap-6 py-6">
      <PageHeader
        title="Admitted Students"
        subtitle="The students your institution uploaded; each claims their record and may then ask for a bursary"
        actions={<Select aria-label="Academic year" value={year} onChange={(e) => setYear(e.target.value)} options={years} className="w-44" />}
      />
      {year && <AdmittedStudentsTable list={bursariesApi.myStudents} params={{ academicYearId: year }} exportName="admitted-students" />}
    </Container>
  );
}
